export const waitingRoom = (timestamp: number) => ({
  timestamp: timestamp || Date.now() + 3500,
  init() {
    const now = Date.now();
    if (now < this.timestamp) {
      const timeUntilReload = this.timestamp - now;
      const delay = timeUntilReload > (60 * 60 * 24 * 1000) ? (60 * 60 * 24 * 1000) : timeUntilReload;
      setTimeout(() => location.reload(), delay);
    }
  },
});
